import { Button } from "@/shared/ui";
import AlertCircleComponent from "./alert-circle";

const UnsavedDataModalContents = ({
    leaveWithoutSaving,
    saveAndContinue
}: {
    leaveWithoutSaving: () => void;
    saveAndContinue: () => void;
}) => {
    return (
        <div className="flex flex-col items-center gap-[.4375rem]">
            <AlertCircleComponent />
            <div className="flex flex-col items-center gap-[1.25rem]">
                <div className="flex flex-col gap-[.625rem] sm:gap-[1.25rem]">
                    <h2 className="font-agrandir text-28 sm:text-30 leading-[140%] text-center">
                        Do you want to stay and save your changes?
                    </h2>
                    <span className="font-atkinsonHyperlegible text-15 sm:text-18 leading-[130%] text-center">
                        If you leave this page now, your changes will not be saved.
                    </span>
                </div>

                <div className="flex flex-col gap-[15px] w-full">
                    <Button
                        className="about_you__save_btn"
                        type="button"
                        variant="contained"
                        color="primary"
                        testId="button-dob-gender-continue"
                        fontClassName="font-bold"
                        onClick={saveAndContinue}
                    >
                        Stay and continue editing
                    </Button>

                    <Button
                        className=""
                        variant="outlined"
                        onClick={leaveWithoutSaving}
                        testId="button-dob-gender-back"
                        fontClassName="font-bold"
                    >
                        Leave without saving
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UnsavedDataModalContents;